var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-share-bar__desktop"},[_c('s-facebook',{staticClass:"social-share-bar__desktop__link",attrs:{"share-options":{
      url: _vm.url,
      quote: _vm.quote,
      hashtags: _vm.hashtags,
    }}},[_c('SocialIconFacebookBlack')],1),_vm._v(" "),_c('s-pinterest',{staticClass:"social-share-bar__desktop__link",attrs:{"share-options":{
      url: _vm.url,
      description: _vm.quote,
    }}},[_c('SocialIconPinterestBlack')],1),_vm._v(" "),_c('s-whats-app',{staticClass:"social-share-bar__desktop__link",attrs:{"share-options":{
      text: _vm.whatsappMessage,
    }}},[_c('SocialIconWhatsAppBlack')],1),_vm._v(" "),_c('div',{staticClass:"social-share-bar__desktop__link"},[_c('LinkBlack',{staticClass:"social-share-bar__desktop__copy",on:{"click":_vm.copyToClipboard}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }